import { collection, getDocs } from 'firebase/firestore';
import { default as React, useEffect, useState } from "react";
import '../HomePage.css';
import { firestore } from "../firebase";

function Window(props) {
  const { windowColor, topbarColor, bgColor, collectionName } = props;
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const windowStyle = {
    backgroundColor: windowColor,
  };

  const topStyle = {
    backgroundColor: topbarColor,
  };
  const bgStyle = {
    color: bgColor,
  };

  useEffect(() => {
    const fetchData = async () => {
      const windowCollectionRef = collection(firestore, collectionName); 
  
      try {
        const querySnapshot = await getDocs(windowCollectionRef);

        const data = [];
        querySnapshot.forEach((doc) => {
          if (doc.exists()) {
            data.push(doc.data());
          } else {
            console.log('No such document for document ID:', doc.id);
          }
        });

        setDataList(data);
        setIsLoading(false); 
      } catch (error) {
        console.error('Error fetching documents:', error);
      }
    };

    fetchData();
  }, [collectionName]);


  return (
    <div className='window-container'>
      {isLoading ? (
       <center><div className="loader">Loading...</div></center> 
      ):(<div></div>)}
      {dataList.map((data, index) => (
        <div className='window' style={windowStyle} key={index}>
          <div className='window-topbar' style={topStyle}>
            <div className='window-topbar-circle-container'>
              <div className="window-topbar-circle" style={{ backgroundColor: '#F74544' }} />
              <div className="window-topbar-circle" style={{ backgroundColor: '#FBB016' }} />
              <div className="window-topbar-circle" style={{ backgroundColor: '#38C228' }} />
            </div>
          </div>
          <div className='window-content' style={bgStyle}>
            <h3>{data.title}</h3>
            {data.img ? <img src={data.img} className='window-image' alt='p'></img>
            : ''}
            {data.link
              ?  <a href={`http://${data.link}`} target="_blank" rel="noopener noreferrer">
              link
            </a>
              : ''
            }
            <p>{data.content}</p>
            {data.updated
              ? `date: ${data.updated.toDate().toISOString().split('T')[0]}`
              : ''
            }
          </div>
        </div>
      ))}
    </div>
  );
  
}

export default Window;
